// The product's name and wording in one place, so renaming Keyring later means editing this file
// (and index.html's <title>), not hunting through every screen.

export const PRODUCT = {
  name: 'Keyring',
  tagline: 'Your home loan, from first look to last payment',
  // The web address as people see it written (the coming-soon graphic spells it this way)
  domain: 'MyKeyRing.ai',
} as const;
